import { render } from "./App.vue?vue&type=template&id=19e7c55a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=19e7c55a&lang=css"

import exportComponent from "D:\\idea_workspace\\dumpling\\web-homework\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__